export default __webpack_public_path__ + "static/media/medidas_cintura_cadera.685fae18.png";